export default "__VITE_ASSET__DXPHH1Xw__"